// extracted by mini-css-extract-plugin
export var amount = "styles-module--amount--2a20d";
export var button = "styles-module--button--f17eb";
export var container = "styles-module--container--e18b3";
export var content = "styles-module--content--11aed";
export var description = "styles-module--description--0d442";
export var firstTitle = "styles-module--firstTitle--52ba4";
export var freebet = "styles-module--freebet--6fbf1";
export var image = "styles-module--image--3c21b";
export var imageMobile = "styles-module--imageMobile--5234e";
export var images = "styles-module--images--75534";
export var ru = "styles-module--ru--6781a";
export var rulesLink = "styles-module--rulesLink--0b0a9";
export var secondTitle = "styles-module--secondTitle--223c1";
export var text = "styles-module--text--75c26";
export var title = "styles-module--title--e8a5c";